module.exports = __webpack_public_path__ + "static/media/punchce.5b2b7fd5.png";